import { render, staticRenderFns } from "./checkbox.vue?vue&type=template&id=ec2653b2&scoped=true&"
import script from "./checkbox.vue?vue&type=script&lang=js&"
export * from "./checkbox.vue?vue&type=script&lang=js&"
import style0 from "./checkbox.vue?vue&type=style&index=0&id=ec2653b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2653b2",
  null
  
)

export default component.exports